const coSimpliMapBtns = document.querySelectorAll('.co-simpli-map-button');
const coSimpliMapOverlay = document.querySelector('.co-simpli-map-overlay');
const coSimpliMapContent = document.querySelectorAll('.co-simpli-content');
const coSimpliResetBtn = document.querySelector('.co-simpli-main-close');
coSimpliMapBtns.forEach((item, index) => {
  item.addEventListener('click', () => {
    if (item.classList.contains('co-active')) {
      return;
    }
    coSimpliMapBtns.forEach(tab => tab.classList.remove('co-active'));
    coSimpliMapContent.forEach(content => content.classList.remove('co-active'));
    item.classList.add('co-active');
    coSimpliMapContent[index].classList.add('co-active');
    coSimpliMapOverlay.classList.add('co-active');
  });
});
coSimpliResetBtn.addEventListener('click', () => {
  coSimpliMapBtns.forEach(tab => tab.classList.remove('co-active'));
  coSimpliMapContent.forEach(content => content.classList.remove('co-active'));
  coSimpliMapOverlay.classList.remove('co-active');
  document.body.classList.remove('co-map-active');
  if (coSimpliResetBtn.classList.contains('co-active-initial')) {
    coSimpliResetBtn.classList.remove('co-active-initial');
  }
});
function initializeTabs(options) {
  const buttons = document.querySelectorAll(options.buttonClass);
  const contents = document.querySelectorAll(options.contentClass);
  const resetButton = options.resetButtonClass ? document.querySelector(options.resetButtonClass) : null;
  const additionalTriggers = options.additionalTriggers ? document.querySelectorAll(options.additionalTriggers) : null;
  function activateTab(index) {
    buttons.forEach(btn => {
      btn.classList.remove('co-active', 'co-active-initial');
    });
    contents.forEach(content => content.classList.remove('co-active', 'co-active-initial'));
    if (additionalTriggers) {
      additionalTriggers.forEach(trigger => {
        trigger.classList.remove('co-active', 'co-active-initial');
      });
    }
    buttons[index].classList.add('co-active');
    contents[index].classList.add('co-active');
    if (additionalTriggers) {
      additionalTriggers[index].classList.add('co-active');
    }
    if (resetButton) {
      resetButton.classList.add('co-active');
    }
    document.body.classList.add('co-map-active'); 
  }
  buttons.forEach((button, index) => {
    button.addEventListener('click', () => {
      if (button.classList.contains('co-active')) {
        return;
      }
      activateTab(index);
    });
  });
  if (additionalTriggers) {
    additionalTriggers.forEach((trigger, index) => {
      trigger.addEventListener('click', () => {
        if (trigger.classList.contains('co-active')) {
          return;
        }
        activateTab(index);
      });
    });
  }
  if (resetButton) {
    resetButton.addEventListener('click', () => {
      buttons.forEach(btn => btn.classList.remove('co-active', 'co-active-initial'));
      contents.forEach(content => content.classList.remove('co-active', 'co-active-initial'));
      resetButton.classList.remove('co-active', 'co-active-initial'); 
      if (additionalTriggers) {
        additionalTriggers.forEach(trigger => trigger.classList.remove('co-active', 'co-active-initial'));
      }
      document.body.classList.remove('co-map-active');
    });
  }
}
initializeTabs({
  buttonClass: '.co-simpli-peru-circle-button',
  contentClass: '.co-simpli-peru-content-tab',
  resetButtonClass: '.co-simpli-peru-content-tab-close',
  additionalTriggers: '.co-simpli-peru-circle'
});
initializeTabs({
  buttonClass: '.co-simpli-spain-circle-button',
  contentClass: '.co-simpli-spain-content-tab',
  resetButtonClass: '.co-simpli-spain-content-tab-close',
  additionalTriggers: '.co-simpli-spain-circle'
});
initializeTabs({
  buttonClass: '.co-simpli-ukraine-circle-button',
  contentClass: '.co-simpli-ukraine-content-tab',
  resetButtonClass: '.co-simpli-ukraine-content-tab-close',
  additionalTriggers: '.co-simpli-ukraine-circle'
});
initializeTabs({
  buttonClass: '.co-simpli-paraguay-circle-button',
  contentClass: '.co-simpli-paraguay-content-tab',
  resetButtonClass: '.co-simpli-paraguay-content-tab-close',
  additionalTriggers: '.co-simpli-paraguay-circle'
});
initializeTabs({
  buttonClass: '.co-simpli-bolivia-circle-button',
  contentClass: '.co-simpli-bolivia-content-tab',
  resetButtonClass: '.co-simpli-bolivia-content-tab-close',
  additionalTriggers: '.co-simpli-bolivia-circle'
});
initializeTabs({
  buttonClass: '.co-simpli-argentina-circle-button',
  contentClass: '.co-simpli-argentina-content-tab',
  resetButtonClass: '.co-simpli-argentina-content-tab-close',
  additionalTriggers: '.co-simpli-argentina-circle'
});
initializeTabs({
  buttonClass: '.co-simpli-greece-circle-button',
  contentClass: '.co-simpli-greece-content-tab',
  resetButtonClass: '.co-simpli-greece-content-tab-close',
  additionalTriggers: '.co-simpli-greece-circle'
});